var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.State.isPartner === false)?_c('h2',{staticClass:"title"},[_vm._v("Stel uw eigen pakket in 5 stappen samen")]):_vm._e(),_vm._v(" "),_c('postcode-check',_vm._g({},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }